



















import { Component,Prop, Vue } from 'vue-property-decorator';
import FlexToolbar from "@/components/FlexToolbar.vue";
// TODO:Propでタイトルとボタンリストを渡せるようにする
@Component({
  components: {
     FlexToolbar,
  }
})
export default class App extends Vue {

}
// <script>

// export default {
//   name: "App",
// };
